import React from 'react';
import {TimePicker} from 'antd';
import commonRefHOC from '../../commonRefHOC';

export default commonRefHOC(TimePicker);